export default __webpack_public_path__ + "static/impact-photo-Joey-68ddb39cb953fe9efbaeb0859a3acd67.png";